import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistaflexsealplusImg from '@/assets/images/products/vistaflexsealplus.png';

const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaFlexSealPlus = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Flex Seal +"
        subTitle="(2K Acrylic Cementitious Waterproofing Coating)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          imageUrl={vistaflexsealplusImg}
          title="Description"
          content="Vista Flex Seal+ is a cementitious waterproofing coating that comes as a ready-to-use two-component system—comprising carefully graded aggregates and selected acrylic polymers. It is highly recommended for waterproofing concrete."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Easy to apply by brush",
                "Exhibits good waterproofing characteristics",
                "No additional water required to make the slurry",
                "Pre-batched components",
                "Can be used on hairline cracks",
              ],
              [
                "Quick mixing",
                "Very good adhesion with substrates",
                "Non-corrosive",
                "Can be used for potable water contact",
                "Protects concrete against water penetration, chloride, and carbonation",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Area of Application">
          <Paragraph content="Vista Flex Seal+ is recommended for use in structural concrete, particularly in:" />
          <CustomLists
            items={[
              [
                "Basements",
                "Roof slabs and screeds",
                "Water tanks & water retaining structures",
                "Swimming pools, toilets, water retaining structures",
              ],
              [
                "Internal & external plastering",
                "Bathrooms, balconies, sumps, and drains",
                "All masonry surfaces (internal and external)",
                "Basements, tunnels, machinery pits, cisterns, reservoirs",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                [
                  "Compressive Strength at 27°C",
                  "3 days - 2.2 N/mm²\n28 days - 21 N/mm²",
                ],
                [
                  "Tensile Strength",
                  "4.56 N/mm² after 14 days exposure",
                ],
                [
                  "Mixing",
                  "Used as slurry - Part A : Part B = 1:4 (by weight)",
                ],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Safety and Precautions">
          <CustomLists
            items={[
              [
                "In case of eye contact, wash with plenty of clean water and seek medical advice.",
                "If swallowed, seek medical attention immediately. Do not induce vomiting.",
                "In case of skin contact, rinse with clean water, then wash with soap. Do not use solvent on the affected area.",
              ],
              [
                "Avoid contact with skin and eyes. Do not ingest.",
                "Ensure adequate ventilation and avoid inhaling vapors.",
                "Wear protective clothing, gloves, and eye protection.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaFlexSealPlus;
